'use strict';

angular.module('internal.setup')
    .directive('internalSetupNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'setup/components/setup-navigation/setup-navigation.html',
            replace: true,
            controller: ('internalSetupNavigation', ['$scope', '$state', '$window', '$rootScope', 'Enterprise', function ($scope, $state, $window, $rootScope, Enterprise) {
                $scope.navigationParameters = {
                    state: "internal.setup.enterprise",
                    objectGroup: "Enterprise"
                }
                $scope.navigationChange = function (record) {
                    //Check whether this is CF page or angular/react page
                    var angularURL = $state.href(record.state);
                    if (angularURL != null) {
                        $state.go(record.state);
                    }
                    else {
                        $window.location.href = $rootScope.internalURL + "license/" + record.address;
                    }
                }

                Enterprise.get().then(function (enterprise) {
                    if (enterprise != null) {
                        var rw_api_key = (enterprise.report_writer_api_key === null ? "" : enterprise.report_writer_api_key);
                        var rw_url = (enterprise.report_writer_url === null ? "" : enterprise.report_writer_url);
                        var rw_active = enterprise.reportwriter_enabled;
                        $scope.enableRW = rw_active && (rw_api_key !== "" && rw_url !== "");
                    }
                });
            }])
        };
    }])
;